import { Feature, Geometry } from 'geojson';
import { useForm, useFormContext } from 'react-hook-form';

import { ThreatType } from '@/api/rest/resources/types/fact';
import { UnitEnum } from '@/api/rest/resources/types/units';

export type InteractiveMapCellProperties = {
  cell_id: string;
  habitat_intactness_latest: number;
  habitat_intactness_baseline: number;
  area_cut: number;
  is_cut: boolean;
  habitat_intactness_trend: number;
  base_year: string;
  target_year: string;
  area_units: UnitEnum;
};

export enum InteractiveMapLayer {
  HabitatIntactness = 'habitatIntactness',
}

export enum InteractiveMapFormFields {
  Year = 'year',
  IndicatorLayer = 'indicatorLayer',
  ThreatFilters = 'threatFilters',
  Cell = 'cell',
}

export type CellFeature = Feature<Geometry, InteractiveMapCellProperties>;

export type ControlsFormFieldValues = {
  [InteractiveMapFormFields.Year]: string;
  [InteractiveMapFormFields.IndicatorLayer]?: InteractiveMapLayer;
  [InteractiveMapFormFields.ThreatFilters]?: ThreatType[] | null;
  [InteractiveMapFormFields.Cell]?: CellFeature | null;
};

export type FilterField = keyof Pick<ControlsFormFieldValues, typeof InteractiveMapFormFields.ThreatFilters>;

export const useInteractiveMapControlsForm = useForm<ControlsFormFieldValues>;

export const useInteractiveMapControlsContext = useFormContext<ControlsFormFieldValues>;
